module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '2ejpx6yg',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
